import jsonata from 'jsonata';

/**
 * @deprecated This method will be removed in future versions. Use 'normalizeStoresStock' instead.
 * JSONata schema https://try.jsonata.org/807jZei2P
 */

export function normalizeStores(stores: ExtStore[]): NormalizedStores {
    /**
     * JSONata schema https://try.jsonata.org/807jZei2P
     */
    const schema = `{
        "byId": {
            id: {
                "id": id,
                "type": type,
                "name": name,
                "address": address,
                "location": location,
                "attributes": attributes
            }
        },
        "allIds": $count($[]) > 0 ? $[].id : [],
        "selectedStore": "",
        "selectedRegionId": "",
        "selectedProvinceId": "",
        "selectedCityId": ""
    }`;

    // eslint-disable-next-line
    return jsonata(schema).evaluate(stores) as any;
}

export function normalizeStoresStock(stocks: ExtStoreStock[]): NormalizedStoresStock {
    /**
     * JSONata schema https://try.jsonata.org/yjfRrS6kE
     */
    const schema = `{
        "byId": {
            storeId: {
                "type": type,
                "id": storeId,
                "name": storeName,
                "address": address,
                "products": products,
                "attributes": [
                    {
                        "key": "attentionPlace",
                        "value": attentionPlace
                    },
                    {
                        "key": "businessHours",
                        "value": businessHours
                    }
                ],
                "location": [
                    {
                        "key": "city_code",
                        "value": communeId
                    },
                    {
                        "key": "city",
                        "value": communeName
                    },
                    {
                        "key": "district_code",
                        "value": provinceId
                    },
                    {
                        "key": "district",
                        "value": provinceName
                    },
                    {
                        "key": "country",
                        "value": country
                    },
                    {
                        "key": "region_code",
                        "value": regionId
                    },
                    {
                        "key": "region",
                        "value": regionName
                    }
                ]
            }
        },
        "allIds": [$.storeId]
    }`;

    // eslint-disable-next-line
    return jsonata(schema).evaluate(stocks) as any;
}
